<template>
    <div class="mb-6">

        <v-row>
            <v-col cols="12" md="5">
                <v-form @submit.prevent="register" ref="refRegister" lazy-validation>
                    <v-card :loading="loading" :disabled="dataBanner.length==5">
                        <v-card-title>
                            Subir nuevo mapa
                            <small v-if="dataBanner.length==5">Solo se admite 5 Imágenes</small>
                        </v-card-title>
                        <v-card-text>
                            <!-- banner -->
                            <v-row class="mb-4">
                                <v-col cols="4">
                                    <input type="file"
                                        accept="image/png,image/jpeg,image/jpg"
                                        ref="fileImg"
                                        class="d-none"
                                        @change="previewImage"
                                    >
                                    <v-btn @click="addNewImage" color="primary" class="mb-3" :disabled="loading" block>
                                        Subir <v-icon>mdi-image-plus</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="8">
                                    <v-img
                                        :src="(previewImg!='')?previewImg:'/images/overlay-img.png'"
                                        :lazy-src="(previewImg!='')?previewImg:'/images/overlay-img.png'"
                                        :aspect-ratio="4/2"
                                        color="grey lighten-2"
                                        class="text-right"
                                    >
                                        <v-btn v-if="previewImg!=''" @click="removeImage()" fab x-small dark color="red darken-3">
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-img>
                                </v-col>
                            </v-row>
                            <!-- banner END -->
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                outlined
                                color="error"
                                :disabled="loading"
                                @click="clearData"
                            >Cancelar</v-btn>
                            <v-btn
                                type="submit"
                                color="primary"
                                :loading="loading"
                            >Actualizar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </div>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            itemsCategories: [],
            // banner
            previewImg: '',
            tmpPreviewImg: '',
            dataImg: null,
            dataBanner: []
        }
    },
    props: ['slug'],
    mounted() {
        this.getTableMap();
    },
    methods: {
        // banner
        addNewImage() {
            this.$refs.fileImg.click();
        },
        previewImage (event) {
            const file = event.target.files[0]
            const fileType = file.type
            if (fileType == 'image/jpeg' || fileType == 'image/jpg' || fileType == 'image/png') {
                this.dataImg = (file)
                this.previewImg = URL.createObjectURL(file)
            } else {
                this.$notify.warning('Formato no permitido.');
                return
            }
        },
        removeImage() {
            this.previewImg = ''
            this.dataImg = null
        },
        // end banner
        clearData() {
            this.dataImg = null
            this.previewImg = this.tmpPreviewImg
        },
        /**
         * lista de banners
         */
        async getTableMap() {
            this.overlay = true
            this.dataBanner = []
            await axios.get(`/waiter/get-table-map?slug=${this.slug}`)
            .then((response) => {
                // console.log(response);
                if (response.data != '') {
                    this.previewImg = response.data
                    this.tmpPreviewImg = response.data
                }
                this.overlay = false
            })
            .catch((error) => {
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },
        /**
         * Register new banner
         */
        async register() {
            if (this.$refs.refRegister.validate()) {
                this.errors = {}
                this.loading = true
                const formData = new FormData
                formData.append('img', this.dataImg)
                formData.append('slug', this.slug)
                await axios.post('/waiter/get-table-map', formData)
                .then(response => {
                    // console.log(response);
                    if (response.data == 'ok') {
                        this.$notify.success('Mapa de mesas actualizado correctamente.');
                        this.getTableMap()
                    }
                    this.loading = false
                })
                .catch(error => {
                    // console.log(error);
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.loading = false
                })
            }
        }
    },
}
</script>
